/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagDto
 */
export interface TagDto {
    /**
     * 
     * @type {number}
     * @memberof TagDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TagDto
     */
    key?: string | null;
}

export function TagDtoFromJSON(json: any): TagDto {
    return TagDtoFromJSONTyped(json, false);
}

export function TagDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagDto {
    if ((json === undefined) || (json === null)) {
            return json;
    }
    console.log("out : struct");
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
    };
}

export function TagDtoToJSON(value?: TagDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
    };
}


